import {
    Component, OnDestroy, ContentChild,
    TemplateRef, ElementRef, ChangeDetectorRef, HostListener,
    Input, Output, EventEmitter
} from '@angular/core';

@Component({
    selector: 'modal',
    templateUrl: 'modal.component.html',
    styleUrls: ['modal.component.scss'],
})
export class ModalComponent implements OnDestroy {
    @ContentChild('modalHeader') header: TemplateRef<any>;
    @ContentChild('modalBody') body: TemplateRef<any>;
    @ContentChild('modalFooter') footer: TemplateRef<any>;

    @Input() closeOnClick = true;
    @Input() closeOnEscape = true;

    @Output() opened = new EventEmitter();
    @Output() closed = new EventEmitter();

    @Output() get isOpened(): boolean {
        return this.visible;
    }

    public visible = false;
    public visibleAnimate = false;

    constructor(private elementRef: ElementRef, private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnDestroy() {
        this.close();
    }

    open(): void {
        document.body.classList.add('modal-open');

        this.visible = true;
        setTimeout(() => this.visibleAnimate = true);

        this.opened.emit();
    }

    close(): void {
        document.body.classList.remove('modal-open');

        this.visibleAnimate = false;
        setTimeout(() => {
            this.visible = false;
            this.changeDetectorRef.markForCheck();

            this.closed.emit();
        }, 200);
    }

    @HostListener('click', ['$event'])
    onContainerClicked(event: MouseEvent): void {
        if (this.closeOnClick && (<HTMLElement>event.target).classList.contains('modal') && this.isTopMost()) {
            this.close();
        }
    }

    @HostListener('document:keydown', ['$event'])
    onKeyDownHandler(event: KeyboardEvent) {
        if (this.closeOnEscape && event.key === 'Escape' && this.isTopMost()) {
            this.close();
        }
    }

    isTopMost(): boolean {
        return !this.elementRef.nativeElement.querySelector(':scope modal > .modal');
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/modal.component.ts